import React from 'react';
import { Button, Card, Space, Typography } from 'antd';
import { MinusOutlined, PlusOutlined } from '@ant-design/icons';

const { Text } = Typography;

export default function KermesQuantityCard({
    icon,
    title,
    value,
    onChange,
    disabled = false
}) {
    const setValue = (next) => onChange(Math.max(0, Number(next) || 0));

    return (
        <Card
            style={{ height: '100%' }}
            styles={{ body: { padding: 18 } }}
        >
            <Space orientation="vertical" size={14} style={{ width: '100%' }}>
                <Text strong style={{ fontSize: 20 }}>
                    {icon} {title}
                </Text>

                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: 18
                    }}
                >
                    <Button
                        danger
                        type="primary"
                        shape="circle"
                        size="large"
                        icon={<MinusOutlined />}
                        disabled={disabled || value <= 0}
                        onClick={() => setValue(value - 1)}
                        style={{
                            width: 64,
                            height: 64,
                            fontSize: 28
                        }}
                    />

                    <span
                        style={{
                            minWidth: 80,
                            textAlign: 'center',
                            fontSize: 48,
                            fontWeight: 700,
                            lineHeight: 1
                        }}
                    >
                        {value}
                    </span>

                    <Button
                        type="primary"
                        shape="circle"
                        size="large"
                        icon={<PlusOutlined />}
                        disabled={disabled}
                        onClick={() => setValue(value + 1)}
                        style={{
                            width: 64,
                            height: 64,
                            fontSize: 28
                        }}
                    />
                </div>

                <Space.Compact block>
                    <Button
                        size="large"
                        block
                        disabled={disabled}
                        onClick={() => setValue(value + 1)}
                    >
                        +1
                    </Button>
                    <Button
                        size="large"
                        block
                        disabled={disabled}
                        onClick={() => setValue(value + 5)}
                    >
                        +5
                    </Button>
                    <Button
                        size="large"
                        block
                        disabled={disabled}
                        onClick={() => setValue(value + 10)}
                    >
                        +10
                    </Button>
                </Space.Compact>
            </Space>
        </Card>
    );
}
